var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",attrs:{"id":"header"}},[_c('iframe',{staticStyle:{"overflow":"hidden"},attrs:{"name":"VeeamProduct","src":"https://partnerportal.sophos.com/en-us/microsite/overview.aspx?partner_referral_id=0013Z00001mP5zE&partner_name=PWA","scrolling":"yes","title":"sophos","width":"100%","height":"100%","frameborder":"0"}})])
}]

export { render, staticRenderFns }